import React from "react";
import clsx from "clsx";
import AddButtonNew from "../../AddButton/AddButtonNew";
import SurveyFormBuilderErrors from "../SurveyFormBuilderErrors"

class SurveyFormBuilderFormFields extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      selected:false
    }

    this.onAddFormField = this.onAddFormField.bind(this);
    this.onRemoveFormField = this.onRemoveFormField.bind(this); 
    this.onChange = this.onChange.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.renderRemoveButton = this.renderRemoveButton.bind(this);
    this.getFormFieldIndexById = this.getFormFieldIndexById.bind(this)
  }

  render() {
    var self = this
    $(function() {
      $( "#sortable").sortable({
        handle: ".handle",
        axis: "y",
        stop: function(event,ui) {
          var idsInOrder = $( "#sortable" ).sortable( "toArray" )
          self.props.onChangeOrder(idsInOrder) 
        }
      });
    });
    
    var tabClasses = clsx({
      'active': this.props.active_tab == 'form_fields',
      'tab-pane': true
    })
    
    return (
      <div className={tabClasses} id="form_fields">
        {this.renderErrors()}
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default" >
              <div className="panel-heading flexed add-button-pannel">
                <div className="col-md-6">
                <h3 className="panel-title">
                  {`${I18n.t('form_fields')}*`}
                </h3>
                </div>
                <div className="col-md-6 content-right flexed">
                  <AddButtonNew
                    new_button={false}
                    model="FormField"
                    text={I18n.t('add')}
                    ids={this.props.form_fields ? this.props.form_fields.map((form_field) => { return form_field.id }) : null}
                    onAdd={this.onAddFormField}
                    buttonClasses="btn btn-secondary"
                    all_forms={this.props.all_survey_forms}
                    generalPosition="left"
                    sortData= {true}
                    survey_form_present={true}
                  />  
                </div>
              </div>
              <div className="panel-body flexed">
                {this.renderFormFields() }
              </div>
            </div>
          </div>
        </div>
      </div>  
    )
  }

  renderFormFields() {
    var self = this;
    if (this.props.form_fields.length == 0) {
      return (
        <div className="no-records col-md-12">
          <span className="none">{I18n.t('none')}</span>
        </div>
      )
    }
    var form_fields = this.props.form_fields.map(function (form_field, idx) {
      return (
        <div className="row" id={form_field.id} key={idx} style={{background: "#efefef", border: "1px solid #dddddd", flexWrap:"nowrap"}}>
          <div className="col-md-10"> 
            <div className='content-div'>
              <span className="handle">&#9776;</span>
              {form_field.field}
            </div>
          </div>
          {self.renderRemoveButton(form_field.id)}
        </div>
      )
    })

    return (
      <div className="container" id='sortable'>
        {form_fields}
      </div>
    )
  }

  renderRemoveButton(id) {
    if (typeof this.onRemove == 'function') {
      return (
        <div className="col-md-2" style={{padding:'10px'}}>
          <button type="button" style={{float: 'right'}} name={id} className="btn btn-secondary" onClick={(e) => this.onRemove(e)}>{I18n.t('remove')}</button>
        </div>
      );
    }
    return null;
  }

  renderErrors() {
    var errors = SurveyFormBuilderErrors.formFieldErrors(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  onAddFormField(form_field) {
    var new_field = []
    this.props.all_form_fields.map((field) =>{
      if(field.id == form_field.id) {
         new_field = field
  
      }
    })
    
    var form_fields = this.props.form_fields.slice(0);
    var form_field = {
      field: new_field.field,
      field_type: new_field.field_type,
      options: new_field.options ? new_field.options : [],
      id: new_field ? new_field.id : '-0',
      rating_range: new_field.rating_range ? new_field.rating_range : '',
      rating_scale_label: new_field.rating_scale_label ? new_field.rating_scale_label : '',
      emoji_rating_label: new_field.emoji_rating_label ? new_field.emoji_rating_label : '',

    };
    form_fields.unshift(form_field);
    this.onChangeSurveyFormFields(form_fields);
  } 

  onRemoveFormField(form_field_id) {
    var form_fields = this.props.form_fields.slice(0);
    var idx = this.getRoomTypeHousekeepingTypeIndexById(form_field_id);
    if (idx >= 0) {
      form_fields.splice(idx, 1);
      this.onChangeRoomTypeHousekeepingTypes(form_fields);
    }
  }

  onChangeSurveyFormFields(form_fields) {
    this.props.onChangeSurveyFormFields({
      target: {
        value: form_fields
      }
    });
  }

  getFormFieldIndexById(id) {
    for (var i = 0, ilen = this.props.form_fields.length; i < ilen; i++) {
      if (this.props.form_fields[i].id == id) {
        return i;
      }
    }
  }

  onChange(event) {
    if (event && event.target) {

      var custom_field_id = event.target.name.split('|')[0]
      var name = event.target.name.split('|')[1]

      if (this.props.form_fields && this.props.form_fields.length) {
        
        for (var i = 0, ilen = this.props.form_fields.length; i < ilen; i++) {
          if (this.props.form_fields[i].id == custom_field_id) {
            this.props.form_fields[i][name] = event.target.value
           
            break
          }
        }
      }
      this.onChangeSurveyFormFields(this.props.form_fields)
    }
  }


  onRemove(e) {
    var form_fields = this.props.form_fields.slice(0);
    var idx = this.getFormFieldIndexById(e.target.name);
    if (idx >= 0) {
      form_fields.splice(idx, 1);
      this.onChangeSurveyFormFields(form_fields);
    }
  }

}

export default SurveyFormBuilderFormFields